/**
 * @file usePortalPageLoader.js
 * @description Shared hook for loading a single portal page's containers and configuration.
 * Used by IndividualHomePage, ViewLivePage, and PreviewTab.
 */
import { useState, useCallback } from 'react';
import Toast from '../components/ui/toasts/Toast';
import { getText } from '../i18n';

function usePortalPageLoader(loadFn) {
    const [fetchedContainers, setFetchedContainers] = useState([]);
    const [fetchedMobileConfiguration, setFetchedMobileConfiguration] =
        useState([]);
    const [portalName, setPortalName] = useState('');
    const [isPageLoading, setIsPageLoading] = useState(false);

    const loadPortalPage = useCallback(
        async id => {
            if (id === undefined || id === null) {
                return;
            }

            try {
                setIsPageLoading(true);
                const fetchedPortalPage = await loadFn(id);
                const viewModel =
                    fetchedPortalPage.viewModels &&
                    fetchedPortalPage.viewModels.length > 0
                        ? fetchedPortalPage.viewModels[0]
                        : null;

                setFetchedContainers(fetchedPortalPage.containers || []);
                setFetchedMobileConfiguration(
                    viewModel?.mobileConfiguration || [],
                );
                setPortalName(viewModel?.name || '');
            } catch (e) {
                console.error(e);
                Toast.error(getText('msg_eeceb57efc21'));
            } finally {
                setIsPageLoading(false);
            }
        },
        [loadFn],
    );

    return {
        fetchedContainers,
        fetchedMobileConfiguration,
        portalName,
        isPageLoading,
        loadPortalPage,
    };
}

export default usePortalPageLoader;
